export default "/images/partner-2.png?a13587560afa46b77f59d0d30f3ee91b";